var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cloud_upload"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3228_388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3228_388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud_upload_2",
    d: "M5.40755 16.6507C4.14366 16.6507 3.0638 16.2132 2.16797 15.3382C1.27214 14.4632 0.824219 13.3938 0.824219 12.1299C0.824219 11.0465 1.15061 10.0813 1.80339 9.23405C2.45616 8.38683 3.31033 7.84516 4.36589 7.60905C4.71311 6.33127 5.40755 5.29655 6.44922 4.50488C7.49089 3.71322 8.67144 3.31738 9.99089 3.31738C11.6159 3.31738 12.9944 3.88335 14.1263 5.0153C15.2583 6.14724 15.8242 7.52571 15.8242 9.15071C16.7826 9.26183 17.5777 9.67502 18.2096 10.3903C18.8416 11.1056 19.1576 11.9424 19.1576 12.9007C19.1576 13.9424 18.793 14.8278 18.0638 15.557C17.3346 16.2861 16.4492 16.6507 15.4076 16.6507H10.8242C10.3659 16.6507 9.97353 16.4875 9.64714 16.1611C9.32075 15.8347 9.15755 15.4424 9.15755 14.984V10.6924L7.82422 11.984L6.65755 10.8174L9.99089 7.48405L13.3242 10.8174L12.1576 11.984L10.8242 10.6924V14.984H15.4076C15.9909 14.984 16.4839 14.7827 16.8867 14.3799C17.2895 13.9771 17.4909 13.484 17.4909 12.9007C17.4909 12.3174 17.2895 11.8243 16.8867 11.4215C16.4839 11.0188 15.9909 10.8174 15.4076 10.8174H14.1576V9.15071C14.1576 7.99794 13.7513 7.0153 12.9388 6.2028C12.1263 5.3903 11.1437 4.98405 9.99089 4.98405C8.83811 4.98405 7.85547 5.3903 7.04297 6.2028C6.23047 7.0153 5.82422 7.99794 5.82422 9.15071H5.40755C4.602 9.15071 3.9145 9.43544 3.34505 10.0049C2.77561 10.5743 2.49089 11.2618 2.49089 12.0674C2.49089 12.8729 2.77561 13.5604 3.34505 14.1299C3.9145 14.6993 4.602 14.984 5.40755 14.984H7.49089V16.6507H5.40755Z",
    fill: "#89AFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.73da52b1bdee17fcc952c144b63ffbc1.svg";
export { ForwardRef as ReactComponent };